// extracted by mini-css-extract-plugin
module.exports = {"courseHours":"CourseHours_courseHours__UkHXg","totalHours":"CourseHours_totalHours__DDnqZ","fieldWrapper":"CourseHours_fieldWrapper__LuK78"};